<template>
  <v-container row justify-center>
    <v-dialog v-model="dialogUploadWizard" persistent max-width="960px">
      <v-row justify="center" no-gutters>
        <v-col>
          <v-card min-height="660px">
            <div class="title-toolbar">
              <v-btn id="upload_wizard__cerrar_ventana__button" class="mr-3 my-0" icon @click="closeWizard">
                <v-icon small>{{ icon.close }}</v-icon>
              </v-btn>
            </div>

            <!-- Stepper -->
            <v-stepper v-model="currentStep">
              <v-stepper-header>
                <template v-for="step in steps">
                  <v-stepper-step
                      :id="`upload_wizard__paso`+step.id+`__stepper`"
                      :color="appThemeComponentsMainColor"
                      :complete="currentStep > step.id"
                      :step="step.id"
                      :key="step.title"
                  >{{ step.title }}</v-stepper-step
                  >
                  <v-divider :key="step.id"></v-divider>
                </template>
              </v-stepper-header>

              <v-progress-linear
                  :indeterminate="this.isBusy"
                  value="100"
                  :color="appThemeComponentsMainColor"
              ></v-progress-linear>

              <v-stepper-items>
                <v-stepper-content
                    v-for="step in steps"
                    :step="step.id"
                    :key="step.id"
                >
                  <component
                      class="component-card"
                      :is="step.component"
                  ></component>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  v-if="currentStep > 1"
                  id="upload_wizard__atras__button"
                  color="success"
                  class="mr-2"
                  @click="this.goBack"
                  :disabled="this.isBusy"
              >Atrás</v-btn
              >
              <v-btn
                  :color="colorButton"
                  id="upload_wizard__siguiente__button"
                  class="mr-5"
                  @click="processStep"
                  :disabled="!this.canGoNext || this.isBusy"
                  :dark="currentStep === this.wizardLength && !this.isBusy"
              >{{ textoButton }}</v-btn
              >
            </v-card-actions>

            <v-row no-gutters>
              <v-col cols="12">
                <notification-container
                    class="mr-5 ml-5"
                    :showOnlyLocalNotifications="true"
                ></notification-container>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>
  </v-container>
</template>

<script>
import { mdiClose } from '@mdi/js'
import {
  panelData,
  panelActions,
  pushNotification,
  appThemeData
} from '@/store/helpers'

import { signersStoreActions } from '@/modules/signers/store/signersStoreHelpers'

import {
  uploadWizardData,
  uploadWizardActions
} from '@/modules/documents/store/uploadWizardStoreHelpers'

import { documentsActions } from '@/modules/documents/store/documentsHelpers'

import AddSigners from '@/modules/signers/components/AddSigners'
import UploadFileList from '@/modules/documents/components/UploadFileList'
import NotificationSettings from '@/modules/documents/components/NotificationSettings'

import { notificationActions } from '@/modules/documents/store/notificationStoreHelpers'

import {
  folderStoreData,
  folderStoreActions
} from '@/modules/catalogs/store/folderStoreHelpers'

export default {
  name: 'UploadWizard',
  components: {
    AddSigners,
    NotificationSettings,
    UploadFileList
  },
  data() {
    return {
      icon: {
        close: mdiClose
      },
      colorButton: 'success',
      textoButton: 'Siguiente',
      defaultFolder: null
    }
  },
  computed: {
    ...uploadWizardData,
    ...panelData,
    ...appThemeData,
    ...folderStoreData,
    currentStep: {
      get() {
        this.setStepAppereance(this.wizardStep)
        return this.wizardStep
      }
    }
  },
  watch: {
    dialogUploadWizard: function(val) {
      if (val && this.wizardStep === 1 && !this.isSetDefaultFolder) {
        this.defaultFolderHasSet()
      }
    }
  },
  methods: {
    ...panelActions,
    ...uploadWizardActions,
    ...documentsActions,
    ...signersStoreActions,
    ...notificationActions,
    ...folderStoreActions,
    setStepAppereance(step) {
      this.textoButton = 'Siguiente'
      this.colorButton = 'success'

      if (step === this.wizardLength) {
        this.textoButton = 'Registrar'
        this.colorButton = 'blue darken-3'
      }
    },
    processStep() {
      if (this.wizardStep === this.wizardLength) {
        this.registerDocuments()
      } else {
        this.goNext()
      }
    },
    async registerDocuments() {
      this.panelBusy()

      let uploadResponse = {
        success: false,
        errorMessage:
            'Ocurrió un error al registrar los documentos favor de contactar al administrador.'
      }
      let errorMessage = ''

      const presignResponse = await this.getUploadPresignUrls()
      const hasError = !presignResponse.success

      if (presignResponse.success) {
        uploadResponse = await this.uploadToS3()
      } else {
        errorMessage = presignResponse.errorMessage
      }

      if (uploadResponse.success) {
        let postUploadActions = new Promise(resolve => {
          let id = setTimeout(() => {
            clearTimeout(id)
            resolve()
          }, 4000)
        })

        postUploadActions.then(async () => {
          this.saveSigners(this.files)
            .then((result) => {
              this.files.map(f => {
                let signers = result.data.filter(d => {
                  return d.idDocumento == f.presignUrl.fields['x-amz-meta-DocumentId']
                })
                
                this.addDocumentInStorage({
                  ...f,
                  idDocumento: f.presignUrl.fields['x-amz-meta-DocumentId'],
                  idCarpeta: f.folder.idCarpeta,
                  idTipoDocumento: f.tipoDocumento,
                  fechaSubidaS3: f.presignUrl.fields['x-amz-meta-UploadDate'],
                  idUsuario: f.presignUrl.fields['x-amz-meta-UserId'],
                  firmantes: signers,
                  estatus: f.presignUrl.fields['x-amz-meta-Status'],
                  linkDescarga: '',
                  vecesDescargado: 0
                })
              })

              this.notifySigners(this.files)
              this.createReminders(this.files)
              this.closeWizard()
            })
            .catch(err => {
              pushNotification(
                this.$store,
                err.errorMessage,
                'error',
                'left',
                false,
                true
              )
            })
            .finally(() => {
              this.panelUnnocupied()
            })
        })
      } else if(uploadResponse) {
        errorMessage = uploadResponse.errorMessage
      }

      if (hasError) {
        this.panelUnnocupied()
        pushNotification(
            this.$store,
            errorMessage,
            'error',
            'left',
            false,
            true
        )
      }
    },
    closeWizard() {
      this.closeUploadWizard()
      this.resetSignersStore()
    }
  }
}
</script>

<style lang="scss" scoped>
.title-toolbar {
  display: grid;
  justify-items: end;
}

.component-card {
  height: 450px;
  overflow-y: auto;
}
</style>
